export default __webpack_public_path__ + "static/home-934736b587748f5df7dfedb79c33c0cb.png";